<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <CSelect
              class="float-left"
              label="Data Per Halaman"
              placeholder="Data Per Halaman"
              @change="changePageSize"
              :options="[10, 25, 50, 100, 'Semua Data']"
            />
          </div>
        </div>

        <div class="col-sm-12 col-xl-4 ml-auto">
          <div class="form-group">
            <CInput
              class="float-right"
              label="Pencarian"
              placeholder="Cari Data .."
              v-model="searchPembayaran"
            />
          </div>
        </div>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">{{ item.nama_lengkap ? item.nama_lengkap : '-' }}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2">{{ item.no_anggota ? item.no_anggota : '-' }}</td>
            </template>
            <template #nama_kap="{item}">
              <td class="py-2">{{ item.nama_kap ? item.nama_kap : '-' }}</td>
            </template>
            <template #nominal="{item}">
              <td class="py-2">Rp. {{ formatPrice(item.nominal) ? formatPrice(item.nominal) : '0' }}</td>
            </template>
           <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_read">
                <CButton
                  color="success"
                  class="btn-sm text-white"
                  @click="detail(item, index)"
                  square>
                <font-awesome-icon icon="eye" /> 
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPagePembayaranOutstanding"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
          <CRow>
            <div class="modal-body row my-n3">
                <div class="col-5">
                    <p class="font-weight-bold">No. Anggota</p>
                    <p class="font-weight-bold">Nama Lengkap</p>
                </div>
                <div class="col-7">
                  <p class="font-weight-bold">: {{ detailUser.no_anggota ? detailUser.no_anggota : '-'  }}</p>
                  <p>: {{detailUser.nama_lengkap}}</p>
                </div>
                <div class="col-md-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="text-center">Periode</th>
                        <th class="text-center">Nominal Tunggakan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in itemsDetails" :key="index">
                        <td class="font-weight-bold text-center">{{ value.periode_iuran }}</td>
                        <td class="text-center">Rp. {{ formatPrice(value.nominal) ? formatPrice(value.nominal) : '0' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
          </CRow>
        <template #header>
        <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
      </template>
        <template #footer class="mt-2">
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import PaymentService from '@/services/finance/payment.service'
import { Pagination } from "@/mixins/Pagination";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from '@/mixins/exportUtils';
import paymentService from '../../../../services/finance/payment.service';

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: true
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: true
  },
  {
    key: "nama_kap",
    label: "Nama KAP",
    sorter: true,
    filter: true
  },
  {
    key: "nominal",
    label: "Total Tunggakan",
    sorter: true,
    filter: true
  },
  {
    key: "aksi",
    label: "Aksi",
    sorter: false,
    filter: false
  },
  
];

export default {
  name: "Payment",
  
  mixins: [Pagination, AlertUtils, exportUtils],
  data() {
    return {
      items: [],
      detailUser : {
        no_anggota : '',
        nama_lengkap : ''
      },
      itemsDetails : [],
      indexed : 0,
      currentPagePembayaranOutstanding: 0,
      fields,
      tipe: 'pembayaran_outstanding',
      no: 1,
      collapseDuration: 0,
      content: [],
      myModal: false,
      title: '',
      role_status: null
    };
  },
  mounted() {
    this.roleData();
    this.getData('0', this.pageSize, this.tipe, this.searchPembayaran, "default", 'default');
  },
  methods: {
     roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/keuangan/pembayaran' );  
      this.role_status = data;
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    lihatDetail(item) {
      this.detailUser.no_anggota = item.no_anggota;
      this.detailUser.nama_lengkap = item.nama_lengkap;
      this.getDetailOutstandingIuran(item.id_user);
    },

    getDetailOutstandingIuran(idUser) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      paymentService.getDetailOutstanding(idUser)
      .then(response => {
        this.itemsDetails = response.data.data
        loader.hide();
      }).catch(error => {
        // comment console console.log(error);
        loader.hide();
      })
    },

    pageChange() {
      this.getData(currenPage);
    },

     changePageSize(e) {
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
        this.getData('0', this.pageSize, this.tipe, this.searchPembayaran, "default", 'default');
    },

    changePelatihan(value) {
      this.periode = value.valuePeriode;
      this.getData("0", this.pageSize, this.tipe, this.searchPembayaran, this.periode , 'default');
    },

    download(value) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.periode = value.valuePeriode
      PaymentService.download(this.tipe, "default", this.filter, 'default')
      .then(response => {
          loader.hide()
          this.exportData(response.data, 'Data-Pembayaran-Iuran-Anggota');
          this.alertExportSuccess();
        })
      .catch(error => {
        this.alertExportFailed();
        loader.hide()
      })  
    }, 

    detail(item, index) {
      this.myModal = true
      this.title = 'Detail Outstanding'
      this.lihatDetail(item);
    },

    getData(currentPage, pageSize, tipe, filter, periode, id) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      PaymentService.getData(
        currentPage,
        pageSize,
        tipe,
        filter,
        periode,
        'default'
      )
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPagePembayaranOutstanding = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
  }
};
</script>